import React, { createContext, useContext, useState, useRef } from 'react'

const GlobalContext = createContext()

export const useGlobalState = () => {
  const context = useContext(GlobalContext)
  if (!context) {
    throw new Error('useGlobalState should be in a GlobalProvider')
  }
  return context
}

export const GlobalProvider = ({ children }) => {
    const [botConfig, setBotConfig] = useState(null)
    const [chatbotList, setChatbotList] = useState([])
    const [lastChatNotification, setLastChatNotification] = useState(null)
    const [chats, setChats] = useState([])
    const [myChats, setMyChats] = useState([])
    const [assignedChats, setAssignedChats] = useState([])

    const _disableNotificationRef = useRef(null)
    const registerDisableNotification = (fn) => { _disableNotificationRef.current = fn }
    const disableNotificationByConversationId = (conversationId) => { _disableNotificationRef.current?.(conversationId) }

    return (
    <GlobalContext.Provider
        value={{
        botConfig,
        setBotConfig,
        chatbotList,
        setChatbotList,
        lastChatNotification,
        setLastChatNotification,
        chats,
        setChats,
        myChats,
        setMyChats,
        assignedChats,
        setAssignedChats,
        registerDisableNotification,
        disableNotificationByConversationId
        }}
>
      {children}
    </GlobalContext.Provider>
  )
}